export default "__VITE_ASSET__vnipeont__"